import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import styled from "@emotion/styled";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { yupResolver } from "@hookform/resolvers/yup";
import { Grid, MenuItem } from "@mui/material";
import { useForm, FormProvider } from "react-hook-form";
import useTenant from "../../../../hooks/useTenant";
import SearchableAutoComplete from "../../../../components/SearchableAutoComplete";
import FilterReset from "../../../../components/FilterReset";
import {
  searchPayload,
  convertedValue,
  invoiceStatusOptions,
  formatDate,
} from "../../../../utils/common";
import ReactHookFormSelect from "../../../../components/ReactHookFormSelect";
import CustomTextField from "../../../../components/CustomTextField";
import { useDialog } from "../../../../contexts/DialogContext";
import usePlan from "../../../../hooks/usePlan";
import CustomDatePicker from "../../../../components/CustomDatePicker";

const currentPayload = {
  filters: [],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};

const statusOptions = [
  {
    label: "Payment Pending",
    value: "PP",
  },
  {
    label: "Un Paid",
    value: "UP",
  },
  {
    label: "Paid",
    value: "PA",
  },
  {
    label: "Canelled",
    value: "CA",
  },
];

function AdvanceFilter(props) {
  const { unSetDialog } = useDialog();
  const today = formatDate(new Date());

  const initialValues = {
    userName: "",
    planName: {},
    activateDateStr: `${today} 00:00:00,${today} 23:59:59`,
    activateDate: [new Date(), new Date()],
  };

  const { fields, payload, setPayload, setFilterResetFunc, filterFormData, setFilterFormData } =
    props;

  const { autoSearchPlan, planAutoSearchResults, isLoadingAutoSearch } = usePlan();

  const [planPayload, setPlanPayload] = useState(currentPayload);
  const [planOptions, setPlanOptions] = useState([]);
  const [defaultPlan, setDefaultPlan] = useState({});

  const { t } = useTranslation();
  const methods = useForm({
    defaultValues: filterFormData || initialValues,
  });

  const {
    reset,
    handleSubmit,
    formState: { errors },
    control,
    watch,
    setValue,
  } = methods;

  useEffect(() => {
    setFilterResetFunc(() => () => reset(initialValues));
  }, [reset]);

  const onSubmit = async (data) => {
    try {
      setFilterFormData(data);
      let filters = [];

      if (data.userName != "" && data.userName != null) {
        filters.push({
          fieldName: "userName",
          fieldValue: data.userName,
          op: "like",
          dataType: "string",
          condition: "and",
          isJoin: false,
        });
      }

      if (data.planName != null && Object.keys(data.planName).length != 0) {
        filters.push({
          fieldName: "planId",
          fieldValue: convertedValue(data.planName, "value").join(","),
          op: "eq",
          dataType: "int",
          condition: "and",
          isJoin: true,
          entityName: "PlanEntity",
          attributeName: "plan",
        });
      }
      if (data.activateDate != "" && data.activateDate != null) {
        console.log(data.activateDateStr, "data.activateDateStr");
        filters.push({
          fieldName: "activateDate",
          fieldValue: data.activateDateStr,
          op: "btn",
          dataType: "date",
          condition: "and",
          isJoin: false,
        });
      }
      setPayload({
        ...payload,
        filters: filters,
      });
      unSetDialog("advance_filter");
    } catch (err) {
      console.error(err, "errerrerrerr");
    }
  };

  const fetchPlan = async () => {
    await autoSearchPlan(planPayload);
  };
  useEffect(() => {
    fetchPlan();
  }, [planPayload]);

  useEffect(() => {
    if (planAutoSearchResults.data.length !== 0) {
      setPlanOptions([...planOptions, ...planAutoSearchResults.data]);
    }
  }, [planAutoSearchResults]);

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={2} pt={8}>
            <Grid item md={6} sm={6} xs={8}>
              <CustomTextField
                label={t("user_name")}
                name="userName"
                control={control}
                fullWidth
                variant="outlined"
                errors={errors}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} pt={8}>
            <Grid item md={6} sm={6} xs={8}>
              <SearchableAutoComplete
                control={control}
                data={planOptions}
                label="Plan Name"
                payload={planPayload}
                setPayload={setPlanPayload}
                loading={isLoadingAutoSearch}
                name="planName"
                multiple={false}
                defaultValue={defaultPlan}
              />
            </Grid>
            <Grid item md={6} sm={6} xs={8}>
              <CustomDatePicker
                name="activateDate"
                nameTemp="activateDateStr"
                label="Activation Date"
                range={true}
                control={control}
              />
            </Grid>
          </Grid>
          <FilterReset resetForm={() => reset(initialValues)} />
        </form>
      </FormProvider>
    </React.Fragment>
  );
}

export default AdvanceFilter;
